import { Grid, Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import "./footer.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Checkbox from "@mui/material/Checkbox";
import Label from "../Label/Label";

export default function MapFooter(props) {
  const {
    // isDisableMultipageMappingLable,
    onClickFooterAction,
    isShowReject,
    isPrevious,
    batchRejection,
    disableSaveAndNext,
    role,
    onClickValidatorView,
    assignToValidator,
    batch_for_qc,
  } = props;

  return (
    <Grid
      container
      className={
        "MapTableFooter"
        // role === "preProcessor" ? "PreMapTableFooter" : "MapTableFooter"
      }
    >
      {/* <Grid item md={6}>
        {!isDisableMultipageMappingLable && (
          <Stack className="StackPage" direction="row" spacing={1}>
            <Chip className="page-no" label="Page1 - Page2" />
            <Chip className="page-no" label="Page1 - Page2" />
          </Stack>
        )}
      </Grid> */}
      <Grid item md={12} className="MapTbleFbuttons">
        {role === "processor" &&
          process.env.REACT_APP_VALIDATOR_FOR_QC === "true" &&
          batch_for_qc === "true" && (
            <div className="checkBox" style={{ paddingRight: "8px" }}>
              <Tooltip title="Validator View" arrow>
                <Checkbox
                  sx={{ padding: 0 }} // Removes padding around the checkbox
                  checked={assignToValidator}
                  onChange={(e) => onClickValidatorView(e.target.checked)}
                />
              </Tooltip>
              <Label text={"Validator View"} fontWeight="400" fontSize="13px" />
            </div>
          )}

        {isShowReject && (
          <div className="checkBox">
            <Tooltip title="Reject Batch" arrow>
              <Checkbox
                sx={{ padding: 0 }}
                checked={batchRejection}
                onChange={(e) => onClickFooterAction("reject", e)}
              />
            </Tooltip>
            <Label text={"Reject"} fontWeight="400" fontSize="13px" />
          </div>
        )}

        {/* {isShowReject && (
          <div className="checkBox">
            <Tooltip title="Reject Batch" arrow>
              <Checkbox
                checked={batchRejection}
                onChange={(e) => onClickFooterAction("reject", e)}
              />
            </Tooltip>
          </div>
        )} */}

        {isPrevious && (
          <Button
            size="medium"
            onClick={(e) => onClickFooterAction("previous")}
            startIcon={<ArrowBackIosIcon />}
          >
            Previous
          </Button>
        )}
        <Button onClick={(e) => onClickFooterAction("cancel")}>Cancel</Button>
        <Button
          onClick={(e) => onClickFooterAction("save")}
          disabled={batchRejection}
        >
          save
        </Button>
        <Button
          className="btn-contained"
          onClick={(e) => onClickFooterAction("saveAndNext")}
          disabled={disableSaveAndNext}
        >
          Save & Next
        </Button>
      </Grid>
    </Grid>
  );
}

MapFooter.defaultProps = {
  isShowReject: true,
  batchRejection: false,
  disableSaveAndNext: false,
};
